import React from "react";
import Panel from "common/components/Panel";
import actions from "../actions";
import CategoriesForm from "../categoriesForm";
import get from "lodash/get";
async function handleSubmit(values, form) {
  const { name } = values;
  const { setSubmitting, setErrors, setStatus, resetForm } = form;
  try {
    await actions.create({ name });
    resetForm();
    setStatus({ success: true });
  } catch (e) {
    const message = get(e, "data.errors[0].msg", e.message);
    setErrors({ name: message || e.message });
  }
  setSubmitting(false);
}

const initialValues = {
  name: "",
};

const CreateCategory = () => (
  <Panel title="Create Category">
    <CategoriesForm handleSubmit={handleSubmit} initialValues={initialValues} />
  </Panel>
);

export default CreateCategory;
